import React, { Component, ErrorInfo, ReactNode } from "react";
import { Box, Typography, Button } from "@mui/material";
import { RefreshCw, Lock, AlertCircle } from "lucide-react";
import {
  backdropStyles,
  modalContentStyles,
  iconContainerStyles,
  messageContainerStyles,
  messageTextStyles,
  reloadButtonStyles,
} from "./styles";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={backdropStyles}>
          <Box sx={modalContentStyles}>
            <Box sx={iconContainerStyles}>
              <AlertCircle size={32} color="#FFFFFF" strokeWidth={2.5} />
            </Box>

            <Box sx={messageContainerStyles}>
              <Lock size={18} color="#D97706" strokeWidth={2.5} />
              <Typography variant="body1" sx={messageTextStyles}>
                It looks like you have an outdated version of the app. Please
                refresh the page to get the latest updates.
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<RefreshCw size={18} />}
              onClick={this.handleReload}
              sx={reloadButtonStyles}
            >
              Reload the Page
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}
